/* eslint-disable no-console */

import { register } from 'register-service-worker'
let staticName = 'capp-precache-v3-https://titlos.web.app/'
// let staticName = `capp-precache-v3-http://127.0.0.1:5000/`
if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' +
          'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered() {
      console.log('Service worker has been registered.')
    },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    updatefound() {
      console.log('New content is downloading.')
      // new content clear cache so user gets the new version
      caches.keys().then((keys) => {
        return Promise.all(
          keys
            .filter((key) => {
              //console.log(key) // старые ключи (три штуки, включая предыдущий (v - 1))
              return key != staticName
            })
            .map((key) => caches.delete(key))
        ).then((empties) => {
          console.log(empties)
        })
      })
    },
    updated(registration) {
      console.log('New content is available; please refresh.')
      // если сюда поместить, то новый cache становится пустым
      document.dispatchEvent(
        new CustomEvent('swUpdated', { detail: registration })
      )
    },
    offline() {
      console.log(
        'No internet connection found. App is running in offline mode.'
      )
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
